<template>
  <table v-if="!isMobile" class="actions">
    <thead>
      <tr>
        <th>Description</th>
        <th>Recipient contact</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Send email to:</td>
        <td>{{ alertEmailContact }}</td>
      </tr>
    </tbody>
  </table>
  <table v-else class="mobile actions">
    <thead>
      <tr>
        <th>Send email to:</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{{ alertEmailContact }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Actions',
  props: {
    alertEmailContact: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isMobile'])
  }
};
</script>

<style lang="scss" scoped>
.actions {
  margin-top: 0.5rem;
  width: 100%;

  th {
    color: $icon-grey;
    height: 3rem;

    &:nth-child(1) {
      width: 12rem;
    }
  }

  td {
    color: $text-black;
  }
}

.mobile {
  &.actions {
    td {
      padding-bottom: 1rem;
    }
  }
}
</style>
